import { useTranslation } from 'react-i18next';
import FlagLanguage from './flag-language';

const languages = {
    fr: { nativeName: 'Français', imgName: 'fr' },
    en: { nativeName: 'English', imgName: 'en' },
    // de: { nativeName: 'Deutsch', imgName: 'de' }
};

export default function I18nComponentChooseLanguage() {
    const { i18n } = useTranslation();

    const handleLanguageChange = (language) => {
        console.log(language);

        localStorage.removeItem('i18nextLng');
        i18n.changeLanguage(language);
    };

    return (
        <div className='text-right'>
            {Object.keys(languages).map((language) => (
                <button
                    key={language}
                    style={{
                        fontWeight: i18n.resolvedLanguage === language ? 'bold' : 'normal',
                    }}
                    type="button"
                    onClick={() => handleLanguageChange(language)}
                >
                    <FlagLanguage language={languages[language].imgName} />
                </button>
            ))}
        </div>
    );
}